
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ClientOnboardingStatus } from 'ah-api-gateways';
import { ClientType } from 'ah-api-gateways';
@Component
export default class ClientListFilters extends Vue {
  private get clientStatusOptions() {
    return [
      {
        label: 'Info Required',
        value: ClientOnboardingStatus.CREATED,
      },
      {
        label: 'Pending',
        value: ClientOnboardingStatus.PENDING,
      },
      {
        label: 'Rejected',
        value: ClientOnboardingStatus.REJECTED,
      },
      {
        label: 'Approved',
        value: ClientOnboardingStatus.APPROVED,
      },
    ];
  }

  private get clientTypeOptions() {
    return [
      {
        label: 'Company',
        value: ClientType.COMPANY,
      },
      {
        label: 'Individual',
        value: ClientType.INDIVIDUAL,
      },
    ];
  }

  private get clientStateOptions() {
    return [
      {
        label: 'Active',
        value: 'ACTIVE',
      },
      {
        label: 'Inactive',
        value: 'INACTIVE',
      },
    ];
  }

  private search = '';

  private clientTypes = [];

  private clientStates = [];

  private clientStatuses = [];

  get allFilters() {
    const out: any = {};

    if (this.search.length) {
      out.query = this.search;
      out.queryBy = ['individuals', 'companyDetails'];
    }
    if (this.clientTypes.length === 1) {
      out.type = this.clientTypes[0];
    }
    if (this.clientStates.length === 1) {
      out.state = this.clientStates[0];
    }
    if (this.clientStatuses.length) {
      out.status = this.clientStatuses;
    }

    return out;
  }

  @Watch('allFilters')
  onFiltersChange() {
    this.$emit('update:filters', this.allFilters);
  }
}
